import { render, staticRenderFns } from "./SpoiledUpload.vue?vue&type=template&id=a3948bfc&scoped=true&"
import script from "./SpoiledUpload.vue?vue&type=script&lang=js&"
export * from "./SpoiledUpload.vue?vue&type=script&lang=js&"
import style0 from "./SpoiledUpload.vue?vue&type=style&index=0&id=a3948bfc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3948bfc",
  null
  
)

export default component.exports